import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { JSX } from 'react';
import { useSearchParams } from 'react-router-dom';
import Content from './content';
import LayoutFooter from './layout/layoutFooter';
import Logo from './logo';

const errorDescriptions = {
  general: {
    title: 'There seems to be a problem loading Fulcrum',
    description1: 'We have let our team know.',
    description2:
      'This problem might be related to your network or internet connection. You could try log out and in again and see if Fulcrum is working properly.',
  },
  noAccess: {
    title: 'You don’t seem to have access to Fulcrum',
    description1: 'If you think you should, please contact support.',
    description2:
      'If you think you have accessed Fulcrum with the wrong profile, please change the profile in VIA and try access Fulcrum again.',
  },
  noContext: {
    title: 'Sorry, this profile can’t use Fulcrum',
    description1:
      'The profile needs to be an adviser profile with active broker and house codes. The adviser also needs to be licensed for Business Assurance.',
    description2:
      'If you think you have accessed Fulcrum with the wrong profile, please change the profile in VIA and try again.',
  },
  noToken: {
    title: 'No token',
    description1:
      'This is a technical error so please contact support to check the profile that you are using to access Fulcrum. Let them know that no token is passed to Fulcrum.',
    description2:
      'If you think you have accessed Fulcrum with the wrong profile, please change the profile in VIA and try again.',
  },
  errorloadingclients: {
    title: 'Sorry, we couldn’t load clients for this profile',
    description1: 'This is a technical error so please contact support for help.',
    description2:
      'If you think you have accessed Fulcrum with the wrong profile, please change the profile in VIA and try again.',
  },
};

const ErrorPage = (): JSX.Element => {
  const [searchParameters] = useSearchParams();
  const description =
    errorDescriptions[searchParameters.get('code') as keyof typeof errorDescriptions] ||
    errorDescriptions.general;

  return (
    <Box className="min-h-screen flex flex-col">
      <Box className="p-4" bgcolor="background.default">
        <Logo />
      </Box>
      <Box bgcolor="white" className="flex-grow">
        <Content>
          <Box className="flex flex-col items-center space-y-8 mt-12">
            <Box color="primary.main">
              <Icon icon="lucide:alert-triangle" width={64} />
            </Box>
            <Typography variant="h2" fontWeight={400} color="primary.main">
              {description.title}
            </Typography>
            <Typography variant="h6" color="text.secondary">
              {description.description1}
            </Typography>
            <Typography variant="h6" color="text.secondary">
              {description.description2}
            </Typography>
          </Box>
        </Content>
      </Box>
      <LayoutFooter />
    </Box>
  );
};

export default ErrorPage;
